import { Link } from 'react-router-dom';

import Image from 'ui/Image';
import Tooltip from 'ui/Tooltip';

import { useAppEnvironmentContext } from '../../contexts/appEnvironmentContext';
import { Path } from '../../utils/routes';

const TopNavLogo: React.FC = () => {
  const { appEnvironment } = useAppEnvironmentContext();
  return (
    <Tooltip content="Go to your home page">
      <Link to={appEnvironment === 'web' ? Path.Sankeys : Path.AddinHome}>
        <Image boxSize={7} src={require('../../assets/logo.svg')} />
      </Link>
    </Tooltip>
  );
};

export default TopNavLogo;
